export default "__VITE_ASSET__D0b2dIyi__"